var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile)?_c('div',{staticClass:"single-profile"},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs,"divider":">"}}),(_vm.profile.status === 'empty')?_c('EmptyProfile',{attrs:{"segment":_vm.profile.slug}}):(
                _vm.profile.status === 'judgment_pending'
                || _vm.profile.status === 'disapproved'
            )?_c('PendingProfile'):_c('Profile',{attrs:{"id":_vm.profile.data.id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }